import React from 'react';
import { PDP_HEADER_TAB_LABEL } from './constants/index';
import PDPWithMap from '../PDPWithMap';
import PDPConnected from '../PDPConnected';
import type { Listing } from '../declarations/Listing';
import type { Brand } from '../declarations/Brand';

export interface TabConfig {
  [key: string]: {
    tabComponent?: React.ReactNode;
    tabPath?: string;
  };
}

export interface Props {
  /*
   * brand
   *
   * the brand
   */
  brand: Brand;
  /*
     * tabConfig
     *
     * the object that sets the tab to the component to render
     *
     * ex:
     * const tabConfig = {
        [PDP_HEADER_TAB_LABEL.APPLICATIONS]: {
            tabComponent: this.renderApplicationsComponent(),
        },
    };
     */
  tabConfig: TabConfig;
  /*
   * isInMobileWebView
   *
   * determins wheather or not do display the My properties breadcrumb
   */
  isInMobileWebView: boolean;
  /*
   * listing
   *
   * the listing model
   */
  listing: Listing;
  /*
   * pathname
   *
   * the current path so the link can be highlighted
   */
  pathname: string;
  /*
   * signMapUrl
   *
   * the signed static map returned from the MUI component
   * see: docs/pdp-header.md for more details
   */
  signMapUrl: () => Promise<string>;
  /*
   * hideTabList
   *
   * hides the tab list
   */
  hideTabList?: boolean;
  /*
   * handleEditClick
   *
   * the event handler for edit listing click (for RMW)
   * if not present we will hide the pencil icon
   */
  handleEditClick?: (event?: Event) => void;
  /*
   * handleBreadcrumbClick
   *
   * the event handler for the breadcrumb
   * if present the link will not preform the default functionality of
   * navigating to the link and preforming a page reload
   */
  handleBreadcrumbClick?: (event?: Event) => void;
  // render custom display name for breadcrumb
  customDisplayName?: string;
  // render custom to href value for breadcrumb
  customHrefValue?: string;
  /*
   * displays that can be overriden
   */
  displayAnalytics?: boolean;
  displayMessages?: boolean; // changed from contacts to messages
  displayApplications?: boolean;
  displayLeases?: boolean;
  displayPayments?: boolean;
}

function PDPHeader(props: Props) {
  const {
    listing: { isConnectedExperience },
  } = props;

  return <>{isConnectedExperience ? <PDPConnected {...props} /> : <PDPWithMap {...props} />}</>;
}

export { PDP_HEADER_TAB_LABEL };
export { PDPHeader };
export default PDPHeader;
